import { createContext, useCallback, useContext, useState } from 'react';
import { Toast, ToastContainer } from 'react-bootstrap';

type ToastVariant = 'danger' | 'success' | 'warning' | 'info';

interface ToastMessage {
    id: number;
    message: string;
    variant: ToastVariant;
}

interface ToastContextValue {
    showToast: (message: string, variant?: ToastVariant) => void;
}

const ToastContext = createContext<ToastContextValue>({
    showToast: () => {},
});

export const useToast = () => useContext(ToastContext);

let nextId = 0;

const ToastProvider = ({ children }: { children: React.ReactNode }) => {
    const [toasts, setToasts] = useState<ToastMessage[]>([]);

    const showToast = useCallback((message: string, variant: ToastVariant = 'danger') => {
        const id = nextId++;
        setToasts((prev) => [...prev, { id, message, variant }]);
        setTimeout(() => {
            setToasts((prev) => prev.filter((t) => t.id !== id));
        }, 5000);
    }, []);

    return (
        <ToastContext.Provider value={{ showToast }}>
            {children}
            <ToastContainer position="bottom-end" className="p-3" style={{ zIndex: 9999 }}>
                {toasts.map((toast) => (
                    <Toast
                        key={toast.id}
                        bg={toast.variant}
                        onClose={() => setToasts((prev) => prev.filter((t) => t.id !== toast.id))}
                        show
                        autohide
                        delay={5000}
                    >
                        <Toast.Header>
                            <strong className="me-auto">
                                {toast.variant === 'danger' && 'Feil'}
                                {toast.variant === 'warning' && 'Advarsel'}
                                {toast.variant === 'success' && 'Suksess'}
                                {toast.variant === 'info' && 'Info'}
                            </strong>
                        </Toast.Header>
                        <Toast.Body className={toast.variant === 'danger' || toast.variant === 'warning' ? 'text-white' : ''}>
                            {toast.message}
                        </Toast.Body>
                    </Toast>
                ))}
            </ToastContainer>
        </ToastContext.Provider>
    );
};

export default ToastProvider;
